export enum UserProperty {
  id = 'id',
  firstname = 'first_name',
  lastname = 'last_name',
  email = 'email',
  password = 'password',
  surveys = 'surveys',
}
